import { render, staticRenderFns } from "./VendorProfileSetup.vue?vue&type=template&id=5a82aa66&scoped=true"
import script from "./VendorProfileSetup.vue?vue&type=script&lang=js"
export * from "./VendorProfileSetup.vue?vue&type=script&lang=js"
import style0 from "./VendorProfileSetup.vue?vue&type=style&index=0&id=5a82aa66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82aa66",
  null
  
)

export default component.exports